import Grid from '@mui/material/Grid2';
import { TextField } from "@mui/material";

export default function ReadOnlyField({ title, value }) {
    return (
        <Grid size={6}>
            <TextField
                label={title}
                value={value || ''}
                readOnly
                fullWidth
                variant='standard'
            />
        </Grid>
    );
}